/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class KioskClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * Get kiosk report statistics (Auth roles: Administrator,Pulinet)
   * @param yearMonth (optional) YearMonth filter
   * @param siteCode (optional) Site filter
   * @return Return kiosk report statistics
   */
  statistics(
    customercode: string,
    yearMonth: Date | undefined,
    siteCode: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<KiosksTotalStatsDTO> {
    let url_ = this.baseUrl + '/kiosk/{customercode}/statistics?';
    if (customercode === undefined || customercode === null)
      throw new Error("The parameter 'customercode' must be defined.");
    url_ = url_.replace('{customercode}', encodeURIComponent('' + customercode));
    if (yearMonth === null) throw new Error("The parameter 'yearMonth' cannot be null.");
    else if (yearMonth !== undefined)
      url_ += 'yearMonth=' + encodeURIComponent(yearMonth ? '' + yearMonth.toJSON() : '') + '&';
    if (siteCode === null) throw new Error("The parameter 'siteCode' cannot be null.");
    else if (siteCode !== undefined) url_ += 'siteCode=' + encodeURIComponent('' + siteCode) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processStatistics(_response);
      });
  }

  protected processStatistics(response: AxiosResponse): Promise<KiosksTotalStatsDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = KiosksTotalStatsDTO.fromJS(resultData200);
      return result200;
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('From-To dates are note in a correct format', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<KiosksTotalStatsDTO>(<any>null);
  }

  /**
   * Get kiosk report statistics for customer (Auth roles: Customer)
   * @param yearMonth (optional) YearMonth filter
   * @param siteCode (optional) Site filter
   * @param kioskId (optional)
   * @return Return kiosk report statistics
   */
  myStatistics(
    yearMonth: Date | undefined,
    siteCode: string | undefined,
    kioskId: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<KiosksTotalStatsDTO> {
    let url_ = this.baseUrl + '/kiosk/my-statistics?';
    if (yearMonth === null) throw new Error("The parameter 'yearMonth' cannot be null.");
    else if (yearMonth !== undefined)
      url_ += 'yearMonth=' + encodeURIComponent(yearMonth ? '' + yearMonth.toJSON() : '') + '&';
    if (siteCode === null) throw new Error("The parameter 'siteCode' cannot be null.");
    else if (siteCode !== undefined) url_ += 'siteCode=' + encodeURIComponent('' + siteCode) + '&';
    if (kioskId === null) throw new Error("The parameter 'kioskId' cannot be null.");
    else if (kioskId !== undefined) url_ += 'kioskId=' + encodeURIComponent('' + kioskId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMyStatistics(_response);
      });
  }

  protected processMyStatistics(response: AxiosResponse): Promise<KiosksTotalStatsDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = KiosksTotalStatsDTO.fromJS(resultData200);
      return result200;
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<KiosksTotalStatsDTO>(<any>null);
  }

  /**
   * Get kiosks for customer (Auth roles: Customer)
   * @param siteCode (optional) Site filter
   * @return Return kiosks
   */
  myKiosks(siteCode: string | undefined, cancelToken?: CancelToken | undefined): Promise<KioskDTO[]> {
    let url_ = this.baseUrl + '/kiosk/my-kiosks?';
    if (siteCode === null) throw new Error("The parameter 'siteCode' cannot be null.");
    else if (siteCode !== undefined) url_ += 'siteCode=' + encodeURIComponent('' + siteCode) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMyKiosks(_response);
      });
  }

  protected processMyKiosks(response: AxiosResponse): Promise<KioskDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(KioskDTO.fromJS(item));
      }
      return result200;
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<KioskDTO[]>(<any>null);
  }
}

export class KioskDTO implements IKioskDTO {
  kioskId?: number;
  kioskName?: string | undefined;
  jobTaskCode?: string | undefined;
  siteCode?: string | undefined;

  constructor(data?: IKioskDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.kioskId = _data['kioskId'];
      this.kioskName = _data['kioskName'];
      this.jobTaskCode = _data['jobTaskCode'];
      this.siteCode = _data['siteCode'];
    }
  }

  static fromJS(data: any): KioskDTO {
    data = typeof data === 'object' ? data : {};
    let result = new KioskDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['kioskId'] = this.kioskId;
    data['kioskName'] = this.kioskName;
    data['jobTaskCode'] = this.jobTaskCode;
    data['siteCode'] = this.siteCode;
    return data;
  }
}

export interface IKioskDTO {
  kioskId?: number;
  kioskName?: string | undefined;
  jobTaskCode?: string | undefined;
  siteCode?: string | undefined;
}

export class KiosksTotalStatsDTO implements IKiosksTotalStatsDTO {
  votesTotal?: number;
  votesAverage?: number;
  votes?: { [key: string]: number } | undefined;
  kioskNames?: string[] | undefined;

  constructor(data?: IKiosksTotalStatsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.votesTotal = _data['votesTotal'];
      this.votesAverage = _data['votesAverage'];
      if (_data['votes']) {
        this.votes = {} as any;
        for (let key in _data['votes']) {
          if (_data['votes'].hasOwnProperty(key)) this.votes![key] = _data['votes'][key];
        }
      }
      if (Array.isArray(_data['kioskNames'])) {
        this.kioskNames = [] as any;
        for (let item of _data['kioskNames']) this.kioskNames!.push(item);
      }
    }
  }

  static fromJS(data: any): KiosksTotalStatsDTO {
    data = typeof data === 'object' ? data : {};
    let result = new KiosksTotalStatsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['votesTotal'] = this.votesTotal;
    data['votesAverage'] = this.votesAverage;
    if (this.votes) {
      data['votes'] = {};
      for (let key in this.votes) {
        if (this.votes.hasOwnProperty(key)) data['votes'][key] = this.votes[key];
      }
    }
    if (Array.isArray(this.kioskNames)) {
      data['kioskNames'] = [];
      for (let item of this.kioskNames) data['kioskNames'].push(item);
    }
    return data;
  }
}

export interface IKiosksTotalStatsDTO {
  votesTotal?: number;
  votesAverage?: number;
  votes?: { [key: string]: number } | undefined;
  kioskNames?: string[] | undefined;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}
